import { useState } from "react";
import { Asset, VehicleCampaigns } from "../models/asset";

function useAssetCampaign() {
    const [campaignSidebar, setCampaignSidebar] = useState(false);
    const [campaigns, setCampaigns] = useState<VehicleCampaigns | undefined>(undefined);
    const [campaignsAssetId, setCampaignsAssetId] = useState<string | null>(null);

    const hasCampaign = (asset: Asset): boolean => {
        return !!((asset?.campaigns?.number ?? 0) > 0)
    };

    const handleCampaignsSidebar = (asset: Asset) => {
        if (!asset.campaigns) {
            console.error("No campaigns found for asset ID:", asset.id);
            return;
        }

        if (!asset.campaigns.list || asset.campaigns.list.length === 0) {
            console.warn("Campaigns exist but the list is empty for asset ID:", asset.id);
            return;
        }

        setCampaignSidebar(!campaignSidebar);
        setCampaigns(asset.campaigns);
        setCampaignsAssetId(asset.id);
    };

    const handleCloseCampaignSidebar = () => {
        setCampaignSidebar(false);
        setCampaigns(undefined);
        setCampaignsAssetId(null);
    };

    return { hasCampaign, handleCampaignsSidebar, handleCloseCampaignSidebar, campaignSidebar, campaigns, campaignsAssetId };
}

export default useAssetCampaign;